if (!customElements.get('f-cart-goal')) {
    class FCartGoal extends HTMLElement {
        constructor() {
            super()

            this.selectors = {
                cartDrawer: '.f-cart-drawer__inner',
                leftToSpend: '[data-left-to-spend]',
                cartGoalTitle: '.f-cartgoal__title',
                defaultMessage: '.f-cartgoal__default-message'
            }

            this.confettiShow = false
            this.goalDone = false
            this.rate = Number(window.Shopify.currency.rate || 1)
            /* Two thresholds: subscription carts can qualify for free shipping
               earlier. Falls back to a single threshold when the subscription
               setting is empty, which is the default.
               A fixed per-currency pair (data-currency-overrides line matching
               the active currency) replaces both AND skips the rate multiply -
               the numbers are already in the presentment currency. */
            const fixed = this.currencyPair()
            if (fixed) {
                this.goalOnetime = fixed.onetime
                this.goalSubscription = fixed.subscription
                this.goal = Number(this.dataset.cartGoal) || 0
            } else {
                this.goalOnetime = Number(this.dataset.cartGoalOnetime || this.dataset.cartGoal) * this.rate || 0
                this.goalSubscription = Number(this.dataset.cartGoalSubscription) * this.rate || 0
                this.goal = Number(this.dataset.cartGoal) * this.rate || 0
            }
            /* Subscribers can get their own wording, so the lower limit reads
               as a perk rather than an unexplained different number. */
            this.msgOnetime = this.dataset.msgOnetime || ''
            this.msgSubscription = this.dataset.msgSubscription || ''
            this.money_format = window.FoxThemeSettings.money_format
            this.enableConfetti = this.dataset.enableConfetti === 'true'
        }

        connectedCallback() {
            this.updateCartGoal(Number(this.dataset.cartTotal))
            window.FoxThemeEvents.subscribe(`ON_CART_UPDATED`, state => {
              this.applyGoalFor(state)
              this.updateCartGoal(state.items_subtotal_price)
            })
            window.FoxThemeEvents.subscribe(`ON_ITEM_ADDED`, async () => {
              const newCart = await window.FoxThemeCartHelpers.getState()
              if (newCart) {
                this.applyGoalFor(newCart)
                this.updateCartGoal(newCart.items_subtotal_price)
              }
            })
            this.confettiShow = this.goalDone
        }

        /* The threshold itself can change mid-session - adding or removing a
           subscription item moves the goalpost - so re-resolve it on every
           cart change rather than reading it once at construction. */
        /* EVERY line must be a subscription. Checkout splits a mixed cart into
           separate shipments and charges each against its own threshold, so a
           mixed cart only ships free once it clears the higher one-time limit.
           Using "some" here would claim free shipping while checkout charges. */
        currencyPair() {
            const code = String((window.Shopify.currency && window.Shopify.currency.active) || '').toUpperCase()
            const fx = String(this.dataset.fxCurrency || '').toUpperCase()
            if (!code || !fx || fx !== code) return null
            const onetime = Number(this.dataset.fxOnetime) || 0
            const subscription = Number(this.dataset.fxSubscription) || 0
            return (onetime > 0 && subscription > 0) ? { onetime, subscription } : null
        }

        cartIsAllSubscription(cart) {
            const items = cart && cart.items
            /* null = cannot tell. Never guess from a payload we did not
               understand - keep whatever Liquid already resolved. */
            if (!Array.isArray(items) || !items.length) return null
            return items.every(item => item && (item.selling_plan_allocation || item.selling_plan))
        }

        applyGoalFor(cart) {
            if (!this.goalSubscription) return
            const allSub = this.cartIsAllSubscription(cart)
            if (allSub === null) return
            const next = allSub ? this.goalSubscription : this.goalOnetime
            if (next && next !== this.goal) {
                this.goal = next
                this.renderMessage(allSub ? this.msgSubscription : this.msgOnetime)
                this.classList.remove('f-cartgoal--done', 'shakeY')
                this.confettiShow = false
            }
        }

        /* Rebuild the message and re-create the amount placeholder, which
           updateCartGoal() then fills. Built from text nodes rather than
           innerHTML so merchant copy can never inject markup. */
        renderMessage(template) {
            if (!template || !this.msgSubscription) return
            const host = this.querySelector(this.selectors.defaultMessage)
            if (!host) return
            while (host.firstChild) host.removeChild(host.firstChild)
            const parts = String(template).split('{{amount}}')
            parts.forEach((part, index) => {
                host.appendChild(document.createTextNode(part))
                if (index < parts.length - 1) {
                    const span = document.createElement('span')
                    span.setAttribute('data-left-to-spend', '')
                    host.appendChild(span)
                }
            })
        }

        updateCartGoal(state) {
            if (state > 0) {
                this.classList.remove('hidden')
            } else {
                this.classList.add('hidden')
            }

            this.cartTotal = state / 100
            this.goalLeft = this.goal - this.cartTotal
            this.goalDone = this.goalLeft <= 0

            this.percent = (this.cartTotal * 100) / this.goal

            if (this.percent >= 100) this.percent = 100

            if (this.cartTotal >= this.goal) {
                this.style.setProperty('--progress', `${this.percent}%`)
                this.classList.add('f-cartgoal--done', 'shakeY')
                this.dataset.total = this.cartTotal
            } else {
                let spend = (this.goal - this.cartTotal) * 100
                const amountEl = this.querySelector(this.selectors.leftToSpend)
                if (amountEl) amountEl.innerHTML = formatMoney(spend, this.money_format)
                this.classList.remove('f-cartgoal--done', 'shakeY')
                this.style.setProperty('--progress', `${this.percent}%`)
                this.dataset.total = this.cartTotal
            }

            if (this.goalLeft <= 0 && this.enableConfetti) {
                this.showConfetti()
            } else {
                this.confettiShow = false
            }
        }

        showConfetti() {  
          const cartDrawer = this.closest(this.selectors.cartDrawer);  
          const cartTemplate = this.closest('.cart-template');  
      
          if (!this.confettiShow && (cartDrawer || cartTemplate)) {  
            setTimeout(() => {  
              if (cartDrawer) {  
                  new window.FoxTheme.Confetti(cartDrawer);  
              }  
              if (cartTemplate) {  
                  new window.FoxTheme.Confetti(document.body);  
              }  
              this.confettiShow = true;
            }, 800);  
          }  
        }  
    }

    customElements.define('f-cart-goal', FCartGoal)
}
